import { defineMessages } from "react-intl";

const messages = defineMessages({
    chooseAnOther: {
        id: "inputSelectCard.chooseAnOther",
    },
    unknownComposer: {
        id: "unknownComposer",
    },
});

export default messages;
